module.exports = __webpack_public_path__ + "static/img/17.61f2b24e.jpg";